import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { MemberBankListStoreContext } from '../contexts/StoreContext'
import { MemberBankListStore } from '../store/interface'

export const useMemberBankListStore: UseStore<
  MemberBankListStore
> = selector => {
  return useContextStore(MemberBankListStoreContext, selector)
}

export const useMemberBankListStoreApi = () => {
  return useContextStoreApi(MemberBankListStoreContext)
}
